/**
 * Handle playing video and video overlay.
 * Play YouTube Videos via JS API postMEssage.
 */
export class VideoCoverPlayer {
	el;
	parent;
	iframe;
	vidSrc;
	vidDataSrc;
	isYoutube;
	bound;

	constructor(el) {
		this.el = el;
		this.parent = this.el.parentNode;
		this.iframe = this.parent.querySelector('iframe');
		this.vidSrc = this.iframe.getAttribute('src');
		this.vidDataSrc = this.iframe.getAttribute('data-src');

		// Bail out if no iframe or no src.
		if (! this.iframe) {
			console.log('No iframe');
			return;
		}

		if (! this.vidSrc && this.vidDataSrc) {
			this.vidSrc = this.vidDataSrc;
			this.observeState(this.bind.bind(this));
		} else {
			this.bind();
		}
	}

	/**
	 * Determine if iframe is loaded and ready to bind.
	 */
	observeState(cb) {
    if (this.iframe.classList.contains('lazyloaded')) {
			cb();
			return;
		}
		const bindFunc = (mutationList, observer) => {
			mutationList.forEach(mutation => {
				if (mutation.type === 'attributes') {
					if (mutation.target.classList.contains('lazyloaded')) {
						cb();
						observer.disconnect();
					}
				}
			});
		}
		const observer = new MutationObserver(bindFunc);
		observer.observe(this.iframe, { attributes: true });
	}

	/**
	 * Bind.
	 * Track bound state to prevent multiple binds from mutation observer.
	 */
	bind() {
		if (this.bound) {
			return;
		}
		this.isYouTube = this.vidSrc.includes('youtube');
		if (! this.isYouTube) {
			this.iframe.setAttribute('src', `${ this.vidSrc }&autoplay=0&rel=0`);
		}
		this.el.addEventListener('click', this.play.bind(this));
		this.bound = true;
	}

	/**
	 * Play video.
	 * Use YT api or swap src attrs.
	 */
	play() {
		this.el.classList.add('js-start-video--hidden');
		if (this.isYouTube) {
			const targetWindow = this.iframe.contentWindow;
			targetWindow.postMessage(
				JSON.stringify({
					event: 'command',
					func: 'playVideo',
					args: [],
				}),
				'*'
			);
		} else {
			const currentVidSrc = this.iframe.getAttribute('src');
			this.iframe.setAttribute(
				'src',
				currentVidSrc.replace('autoplay=0', 'autoplay=1')
			);
		}
	}
}

const videos = document.querySelectorAll('.js-start-video');
document.addEventListener('DOMContentLoaded', () => {
	/**
	 * Setup each cover video.
	 */
	videos.forEach((video) => {
		video = new VideoCoverPlayer(video);
	});
});
